import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { AnswerView } from "../../../atom";
import HeadingComponent from "../../../atom/Headings/Heading";
import _ from "lodash";
import { getSourcePath } from "../../../../core/Constant";

const AdminQuestionView = ({ item }) => {
  const [correctAnswers, setCorrectAnswers] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [images, setImages] = useState([]);

  useEffect(() => {
    let answers = _.get(item, "answers", []);

    // Check if 'answers' is a string (JSON encoded)
    if (typeof answers === "string") {
      try {
        answers = JSON.parse(answers); // Parse it into an array
      } catch (error) {
        console.error("Error parsing answers JSON:", error);
        answers = [];
      }
    }

    // Filter for correct answers
    const correct = _.filter(answers, (answer) => answer.is_correct == 1); // Ensure type consistency

    setAnswers(answers);
    setCorrectAnswers(correct);

    // Handle images - can be from 'images' array (new) or 'image' field (old)
    let imageArray = [];

    // Check for new format: images array
    if (item?.images && Array.isArray(item.images) && item.images.length > 0) {
      imageArray = item.images.map((img) => getSourcePath(img.image_path));
    }
    // Check for old format: single image field
    else if (item?.image) {
      if (Array.isArray(item.image)) {
        // Multiple images in old format
        imageArray = item.image.map((img) => getSourcePath(img));
      } else if (item.image !== null && item.image !== "") {
        // Single image in old format
        imageArray = [getSourcePath(item.image)];
      }
    }

    setImages(imageArray);
  }, [item]);

  return (
    <Box className="admin-question" p={3}>
      {/* Display Images */}
      {images.length > 0 && (
        <Box sx={{ marginBottom: 3 }}>
          <HeadingComponent
            text={"Images"}
            size={25}
            fontweigth={700}
            fontfamily={"Montserrat, sans serif"}
          />
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
              gap: 2,
              marginTop: 2,
              padding: 2,
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              backgroundColor: "#f9f9f9",
            }}
          >
            {images.map((imgSrc, index) => (
              <Box
                key={`image-${index}`}
                sx={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: 1,
                  backgroundColor: "white",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "200px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                    borderRadius: "4px",
                    backgroundColor: "#f5f5f5",
                  }}
                >
                  <img
                    src={imgSrc}
                    alt={`Question Image ${index + 1}`}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      width: "auto",
                      height: "auto",
                      objectFit: "contain", // Ensures image is not cut
                    }}
                  />
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      )}

      <Box>
        <div
          dangerouslySetInnerHTML={{
            __html: `${_.get(item, "question", "")}`,
          }}
        />
      </Box>

      <AnswerView answers={answers} correctAnswers={correctAnswers} />

      <Box mt={3} mb={3}>
        <HeadingComponent
          text={"Reason"}
          size={25}
          fontweigth={700}
          fontfamily={"Montserrat, sans serif"}
        />
        <Box p={2}>
          {item?.reason !== null ? (
            <div
              dangerouslySetInnerHTML={{
                __html: item?.reason,
              }}
            />
          ) : (
            <p>Reason not found</p>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default AdminQuestionView;
